import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FaCheckCircle, FaPrint, FaEnvelope, FaHome, FaShoppingBag } from "react-icons/fa";
import { uploadPaymentSlip } from "../services/orderService";
import Subheader from "../Component/Subheader";
import Footer from "../Component/Footer";
import "../styles/PaymentSuccess.css";

function PaymentSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const { orderId, paymentMethod } = location.state || {};
  
  const [uploading, setUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  useEffect(() => {
    if (!orderId) {
      navigate('/');
    }

    // Check if there's a pending slip upload
    const pendingOrder = localStorage.getItem('pendingOrder');
    if (pendingOrder && paymentMethod === 'bank_transfer') {
      const { orderId: pendingOrderId, slipFile } = JSON.parse(pendingOrder);
      if (pendingOrderId === orderId) {
        handleSlipUpload(pendingOrderId, slipFile);
      }
    }
  }, [orderId, paymentMethod, navigate]);

  const handleSlipUpload = async (orderId, slipFile) => {
    setUploading(true);
    try {
      await uploadPaymentSlip(orderId, slipFile);
      setUploadSuccess(true);
      localStorage.removeItem('pendingOrder');
    } catch (error) {
      console.error('Failed to upload slip:', error);
      alert('Failed to upload payment slip. Please contact support.');
    } finally {
      setUploading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  if (!orderId) {
    return null;
  }

  return (
    <div>
      <Subheader />
      
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="card border-0 shadow-sm">
              <div className="card-body text-center p-5">
                {/* Success Icon */}
                <div className="success-icon mb-4">
                  <FaCheckCircle size={80} className="text-success" />
                </div>

                {/* Success Message */}
                <h2 className="mb-3">Order Placed Successfully!</h2>
                <p className="text-muted mb-4">
                  Thank you for your purchase. Your order has been received and is being processed.
                </p>

                {/* Order Details */}
                <div className="order-details bg-light p-4 rounded mb-4">
                  <h5 className="mb-3">Order Information</h5>
                  <div className="row text-start">
                    <div className="col-md-6">
                      <p><strong>Order ID:</strong> #{orderId}</p>
                      <p><strong>Payment Method:</strong> 
                        {paymentMethod === 'cash' ? ' Cash on Delivery' : ' Bank Transfer'}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>Status:</strong> 
                        {paymentMethod === 'cash' ? ' Processing' : ' Pending Payment Verification'}
                      </p>
                      <p><strong>Date:</strong> {new Date().toLocaleDateString()}</p>
                    </div>
                  </div>
                </div>

                {/* Bank Transfer Instructions */}
                {paymentMethod === 'bank_transfer' && (
                  <div className="bank-instructions alert alert-info text-start">
                    <h6 className="alert-heading">Payment Verification Required</h6>
                    <p className="mb-2">
                      {uploadSuccess 
                        ? 'Your payment slip has been uploaded successfully. We will verify your payment and update the order status shortly.'
                        : 'Please upload your payment slip to complete the order process.'
                      }
                    </p>
                    
                    {!uploadSuccess && !uploading && (
                      <div className="mt-3">
                        <p className="mb-2"><strong>Bank Details:</strong></p>
                        <ul className="list-unstyled">
                          <li><strong>Bank:</strong> Commercial Bank</li>
                          <li><strong>Account:</strong> +94 789621706</li>
                          <li><strong>Name:</strong> Charith Silva</li>
                          <li><strong>Reference:</strong> Order #{orderId}</li>
                        </ul>
                        <p className="mb-0">
                          <strong>Email slip to:</strong> chariths615@gmail.com
                        </p>
                      </div>
                    )}

                    {uploading && (
                      <div className="text-center mt-3">
                        <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                        Uploading payment slip...
                      </div>
                    )}
                  </div>
                )}

                {/* Action Buttons */}
                <div className="action-buttons d-flex justify-content-center gap-3 flex-wrap">
                  <button
                    className="btn btn-outline-primary d-flex align-items-center"
                    onClick={handlePrint}
                  >
                    <FaPrint className="me-2" />
                    Print Receipt
                  </button>
                  
                  <Link
                    to="/"
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <FaHome className="me-2" />
                    Continue Shopping
                  </Link>
                  
                  <Link
                    to="/orders"
                    className="btn btn-success d-flex align-items-center"
                  >
                    <FaShoppingBag className="me-2" />
                    View Orders
                  </Link>
                </div>

                {/* Support Information */}
                <div className="support-info mt-4 pt-3 border-top">
                  <p className="text-muted mb-2">
                    Need help? Contact our support team:
                  </p>
                  <p className="mb-1">
                    <FaEnvelope className="me-2" />
                    <a href="mailto:litegrocer@gmail.com" className="text-decoration-none">
                      litegrocer@gmail.com
                    </a>
                  </p>
                  <p className="mb-0">
                    <strong>Phone:</strong> +94 71 608 2005
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default PaymentSuccess;